  <div *ngIf="greeting" >
  <div class="modal-overlay dialog-card"></div>
    <div class="modal-content">
      
      <div class="message">
        <h2>{{ greeting.type === 'birthday' ? 'Happy Birthday!' : (greeting.type === 'anniversary' ? 'Work Anniversary!' : 'Special Day!') }}</h2>
        <ng-container *ngFor="let msg of greeting.messages">
          <p>{{ msg }}</p>
        </ng-container>
      </div>
      
      <div class="action">
        <button (click)="onDismiss()">Close</button>
      </div>
    </div>
  </div>